// This util could be useful for backbone components
define(function(require, exports, module) {
    'use strict';
    const config = require('config');
    const parseDtagStringToArray = require('util/swiss-theme/parseDtagStringToArray.util');

    const getIsFeatureFlagEnabled = (featureFlagName) => {
        const dynamicTags = config.get('dynamicTags');
        const featureFlags = dynamicTags && dynamicTags?.DTAG_FEATURE_FLAGS;

        if (!featureFlags.includes(',')) {
            return featureFlags === featureFlagName;
        }

        if (featureFlags?.includes(',')) {
            return Boolean(parseDtagStringToArray(featureFlags).find((flag) => flag === featureFlagName));
        }

        return false;
    };

    module.exports = getIsFeatureFlagEnabled;
});
